import React from 'react';
import Donationprogress from '../components/donationProgress';
import Trackdonation from '../components/trackdonationForm';
import { parseMessages } from '../../utilityHelper';
import withTheme from '../../common/withTheme';

const dataObj = {};
try {
	dataObj.trackDonationInfo = JSON.parse(document.getElementById('data-donation-info') && document.getElementById('data-donation-info').innerHTML || '{}');
} catch(e) {
	console.warn('Error while parsing data', e);
}
let slideIndex = 1;

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName('mySlides');
  let dots = document.getElementsByClassName('dot');
  if (n > slides.length) {slideIndex = 1}    
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';  
  }
  for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(' active', '');
  }
  slides[slideIndex-1].style.display = 'block';  
  dots[slideIndex-1].className += ' active';
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

const propertyInfo = parseMessages('trackdonation/dt-home');

class TrackDonationApp extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			trackDonationInfo:dataObj.trackDonationInfo,
			propertyInfo:propertyInfo
		};
	}

	componentDidMount() {
		let slideIndex = 1;
		showSlides(slideIndex);
		window.addEventListener('DOMContentLoaded', () => {
			let dotCircle = document.querySelectorAll('.dotWrap .dot');
			for (let i = 0; i < dotCircle.length; i++) {
				dotCircle[i].addEventListener('click', function () {
					if (this.id == 'dot1') {
						currentSlide(1);
					} else if (this.id == 'dot2') {
						currentSlide(2);
					} else if (this.id == 'dot3') {
						currentSlide(3);
					}
				})
			}
		})
	}
	render() {
		let trackDonationInfo = this.state.trackDonationInfo;
		let propertyInfoMessages = this.state.propertyInfo;
		return (
			<div id="donationTrackerWrapper" className="row">
				{trackDonationInfo.isResult ? <Donationprogress propertyInfo={propertyInfoMessages} trackDonationInfo={trackDonationInfo} /> : <div></div>}
				<Trackdonation propertyInfo={propertyInfoMessages} isResult={trackDonationInfo.isResult} trackanother={trackDonationInfo.trackanother} />
			</div>
		);

	}
}
export default withTheme(TrackDonationApp);